// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__BXrcN","selected":"Tab_selected__eBbZf","label":"Tab_label__OXv2m","hasIcon":"Tab_hasIcon__D_0Db","iconOnly":"Tab_iconOnly__hwD3R"};